import React from 'react'
import Button from '../../atoms/Button/Button'
import Link from 'next/link'
import { getAltText } from '../../../utils/safe'

const StrumentiServiziCard = ({ index, strumento }) => {
  return (
    <div className={'strumenti-card' + (index % 2 ? ' strumenti-card--reversed' : '')}>
      <div className="strumenti-card__content">
        <span className="strumenti-card__index">{index + 1}</span>
        <h3 className="strumenti-card__title">{strumento.titolo}</h3>
        <div
          className="strumenti-card__description"
          dangerouslySetInnerHTML={{
            __html: strumento.testo,
          }}
        ></div>
        {strumento.link && (
          <Link legacyBehavior href={strumento.link}>
            <Button
              className="strumenti-card__cta"
              href={strumento.link}
              label={strumento.cta_link}
              size="large"
              variant="primary"
            />
          </Link>
        )}
      </div>
      <div className={'strumenti-card__img-box'}>
        <img
          src={strumento.immagine?.url}
          className={'strumenti-card__img'}
          alt={getAltText(strumento?.immagine)}
        />
        <div
          className="strumenti-card__caption"
          dangerouslySetInnerHTML={{
            __html: strumento.testo_box,
          }}
        ></div>
      </div>
    </div>
  )
}

export default StrumentiServiziCard
